import { Component, OnInit } from '@angular/core';
import { LoaderIndicatorService } from '../../services/loader-indicator/loader-indicator.service';
import { AuditService } from '../../services/audit/audit.service';
import { ToasterService } from 'angular2-toaster';
import { TranslationService } from '../../services/translation/translation.service';
import { DocumentListItem } from '../../services/audit/document.model';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Audit page component
 */
@Component({
    selector: 'audit',
    styleUrls: ['audit-page.scss'],
    templateUrl: 'audit-page.html'
})
export class AuditPageComponent implements OnInit {

    /**
     * CMR ID
     */
    public cmrId;

    /**
     * Variable for preloader displaying
     */
    public deactivate;

    /**
     * Search result - document list
     */
    public docList: DocumentListItem[];

    /**
     * Show error is not found
     */
    public noMatchFound: boolean;

    /**
     * Current PDF
     */
    public currentPdf: any;

    /**
     * Current PDF name
     */
    public currentPdfName: any;

    /**
     * The "constructor"
     * @param {LoaderIndicatorService} loaderIndicatorService
     * @param {AuditService} auditService
     * @param {TranslationService} translate
     * @param {ToasterService} toasterService
     * @param domSanitizer
     */
    constructor(private loaderIndicatorService: LoaderIndicatorService,
                private auditService: AuditService,
                private translate: TranslationService,
                private toasterService: ToasterService,
                private domSanitizer: DomSanitizer) {
    }

    /**
     * Init audit component
     */
    public ngOnInit() {
        //
    }

    public searchByCmrID() {
        this.noMatchFound = false;
        this.docList = [];
        this.deactivate = this.loaderIndicatorService.activateLoading();
        this.auditService.getDocListByCmrId(this.cmrId).subscribe(content => {
                if (!content) {
                    this.noMatchFound = true;
                }
                this.docList = content;
                this.deactivate();
            },
            err => {
                this.noMatchFound = true;
                this.toasterService.pop('error', err);
                this.deactivate();
            }
        );
    }

    public backToSearch() {
        this.cmrId = '';
        this.docList = [];
        this.currentPdf = null;
        this.currentPdfName = null;
    }

    public openDocument(pdfName: string) {
        this.currentPdfName = pdfName;
        this.deactivate = this.loaderIndicatorService.activateLoading();
        this.auditService.getPdfDoc(pdfName).subscribe(data => {
            if (window.navigator.msSaveOrOpenBlob) {
                // IE11
                window.navigator.msSaveOrOpenBlob(data, pdfName);
            } else {
                // Google chrome, Firefox
                this.currentPdf = this.domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(data));
            }
            this.deactivate();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/audit-page/audit-page.component.ts